<template>
    <div class="tw-tablet-list">
        <!-- 无分组的页面 -->
        <div v-if="pages.length" class="tw-tablet-group" style="margin-bottom:80px;">
            <div class="tw-tablet-item" v-for="file in pages" :key="file.id" :data-page-id="file.id" style="padding:10px; float:left;"
                @dblclick="onOpen(file)" @click="onOpen(file)" :class="{ 'tw-tablet-item-active': file.id === selectId }">
                <div class="tw-tablet-item-thumbnails">
                    <img :src="file.thumbnail">
                </div>
                <div style="text-align:center; color:#909399; margin-top:5px">{{ file.label || '未命名' }}</div>
            </div>
        </div>

        <!-- 有分组的页面 -->
        <template v-for="item in groups" :key="item.id">
            <el-divider content-position="left">{{item.label}}</el-divider>
            <div class="tw-tablet-group">
                <div class="tw-tablet-item" v-for="file in item.children" :key="file.id" :data-page-id="file.id" style="padding:10px; float:left;"
                    @dblclick="onOpen(file)" @click="onOpen(file)" :class="{ 'tw-tablet-item-active': file.id === selectId }">
                    <div class="tw-tablet-item-thumbnails">
                        <img :src="file.thumbnail">
                    </div>
                    <div style="text-align:center; color:#909399; margin-top:5px">{{ file.label || '未命名' }}</div>
                </div>
            </div>
        </template>

        <tw-theme></tw-theme>
    </div>
</template>

<script>
import { onMounted, onUnmounted, ref, inject } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import theme from '../common/theme.vue'

export default {
    name: "tw-tablet-list",
    components: {
        'tw-theme': theme
    },
    setup() {
        const router = useRouter()
        const selectId = ref('')

        const mainMenus = inject('sys_main_menus')
        if (!mainMenus) {
            console.error('无法获取到 sys_main_menus 数据，请检查是否注入问题')
        }

        // 由于有些页面可能直接在根节点上，所以分成两类，一种是在文件夹下的，另一种是直接是页面的
        const groups = mainMenus.filter(el => el.type === 'folder' && !!el.children?.length)
        const pages = mainMenus.filter(el => el.type === 'page' || el.type === 'link')

        const onSelect = function(file) {
            selectId.value = file.id
        }

        const onOpen = function(file) {
            switch (file.type) {
                case 'page':
                    if (file?.file_name) {
                        router.push({ name: file.file_name })
                    } else {
                        ElMessage.info({
                            showClose: true,
                            message: '此项未配置页面！'
                        })
                    }
                    break;
                case 'link':
                    if (file?.url) {
                        window.open(file.url)
                    } else {
                        ElMessage.info({
                            showClose: true,
                            message: '此项未配置外链地址！'
                        })
                    }
                    break;
                default:
                    ElMessage.info({
                        showClose: true,
                        message: `不可识别的页面类型 ${file.type}！`
                    })
                    break;
            }
        }

        // 设置默认选中项
        if (pages.length) {
            onSelect(pages[0])
        } else {
            if (groups.length && groups[0].children.length) {
                onSelect(groups[0].children[0])
            }
        }

        const getTabletItem = function(activeTabletItemId, type) {
            const map = []
            let activeElement = document.querySelector(`[data-page-id="${activeTabletItemId}"]`)
            document.getElementsByClassName('tw-tablet-item').forEach(el => {
                switch (type) {
                    case 'col':
                        if (el.offsetLeft === activeElement.offsetLeft) {
                            const id = el.getAttribute('data-page-id')
                            map.push(id)
                        }
                        break;
                    case 'row':
                        if (el.offsetTop === activeElement.offsetTop) {
                            const id = el.getAttribute('data-page-id')
                            map.push(id)
                        }
                        break;
                    default:
                        break;
                }
            })
            return map
        }

        const onKeyDown = function(e) {
            switch (e.code) {
                case 'Enter':
                    if (selectId.value) {
                        let file = pages.find(el => el.id === selectId.value)
                        if (!file) {
                            let tmp
                            for (let i = 0; i < groups.length; i++) {
                                const group = groups[i];
                                tmp = group.children.find(el => el.id === selectId.value)   
                                if (tmp) {
                                    file = tmp
                                    break;
                                }
                            }
                        }
                        if (file) {
                            onOpen(file)
                        }
                    }
                    break;
                case 'ArrowUp':
                case 'ArrowDown': {
                    let mapCol = getTabletItem(selectId.value, 'col')
                    const indexCol = mapCol.findIndex(el => el === selectId.value)
                    if (e.code === 'ArrowUp') {
                        if (indexCol > 0 ) {
                            selectId.value = mapCol[indexCol-1]
                        } else {
                            // 当前列最前一个时，检查是否有上一行，有则跳到上一行最后一个
                            let mapRow = getTabletItem(selectId.value, 'row')
                            const tabletItemId = mapRow[0]
                            mapCol = getTabletItem(tabletItemId, 'col')
                            const indexCol = mapCol.findIndex(el => el === tabletItemId)
                            if (indexCol > 0) {
                                mapRow = getTabletItem(mapCol[indexCol-1], 'row')
                                selectId.value = mapRow[mapRow.length-1]
                            }
                        }
                    } else {
                        if (indexCol < (mapCol.length - 1)) {
                            selectId.value = mapCol[indexCol+1]
                        } else {
                            // 当前列最后一个时，检查是否有下一行，有则跳到下一行最后一个
                            let mapRow = getTabletItem(selectId.value, 'row')
                            const tabletItemId = mapRow[0]
                            mapCol = getTabletItem(tabletItemId, 'col')
                            const indexCol = mapCol.findIndex(el => el === tabletItemId)
                            if (indexCol < (mapCol.length - 1)) {
                                mapRow = getTabletItem(mapCol[indexCol+1], 'row')
                                selectId.value = mapRow[mapRow.length-1]
                            }
                        }
                    }
                    break;
                }
                case 'ArrowLeft':
                case 'ArrowRight': {
                    let mapRow = getTabletItem(selectId.value, 'row')
                    const indexRow = mapRow.findIndex(el => el === selectId.value)
                    if (e.code === 'ArrowLeft') {
                        if (indexRow > 0 ) {
                            selectId.value = mapRow[indexRow-1]
                        } else {
                            // 往左最前一个时跳到上一行最后一个
                            const tabletItemId = mapRow[0]
                            const mapCol = getTabletItem(tabletItemId, 'col')
                            const indexCol = mapCol.findIndex(el => el === tabletItemId)
                            if (indexCol > 0) {
                                mapRow = getTabletItem(mapCol[indexCol-1], 'row')
                                selectId.value = mapRow[mapRow.length-1]
                            }
                        }
                    } else {
                        if (indexRow < (mapRow.length - 1)) {
                            selectId.value = mapRow[indexRow+1]
                        } else {
                            // 往右最后一个时跳到下一行最前一个
                            const tabletItemId = mapRow[0]
                            const mapCol = getTabletItem(tabletItemId, 'col')
                            const indexCol = mapCol.findIndex(el => el === tabletItemId)
                            if (indexCol < (mapCol.length -1)) {
                                selectId.value = mapCol[indexCol+1]
                            }
                        }
                    }
                    break;
                }
                default:
                    break;
            }
        }

        onMounted(() => {
            document.addEventListener('keydown', onKeyDown, true)
        })

        onUnmounted(() => {
            document.removeEventListener('keydown', onKeyDown, true)
        })

        return {
            groups,
            pages,
            selectId,
            onSelect,
            onOpen
        }
    }
}
</script>

<style>

.tw-tablet-list {
    height: calc(100vh - 60px);
    padding: 20px;
    overflow: auto;
    background-color: white;
}

.tw-tablet-group {
    padding: 0px 0px;
    overflow: auto;
    font-size: 13px;
    font-family: Segoe WPC,Segoe UI,Microsoft YaHei,sans-serif;
}
.tw-tablet-item {
    border: 1px solid transparent;
    margin: 15px;
    cursor: pointer;
}
/* .tw-tablet-item>div:hover {
    background-color: rgba(255, 255, 255, 0.1);
}
.tw-tablet-item-active {
    background-color: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.4) !important;
} */
.tw-tablet-item:hover {
    background-color: rgba(64, 158, 255, 0.2);
    border-radius: 6px;
}
.tw-tablet-item-active {
    background-color: rgba(64, 158, 255, 0.2);
    border: 1px solid rgba(64, 158, 255, 0.6) !important;
    border-radius: 6px;
}
/* 缩略图 */
.tw-tablet-item-thumbnails {
    width: 226px;
    height: 160px;
    background-color:transparent;
    display: table-cell;
    vertical-align: bottom;
}
.tw-tablet-item-thumbnails>img {
    max-width: 226px;
    max-height: 160px;
    display:block;
    margin: 0 auto;
    box-shadow: 2px 2px 5px #888888;
    padding: 3px;
    border-radius: 4px;
    background-color: white;
    /* box-shadow: 2px 2px 5px #000000; */
    /* box-shadow: #000000 0 6px 6px -6px inset; */
}

@media screen and (max-width: 451px) {
    .tw-tablet-item-thumbnails {
        width: 100%;
        height: auto;
        background-color:transparent;
        display: table-cell;
        vertical-align: bottom;
    }
    .tw-tablet-item-thumbnails>img {
        max-width: 100%;
        max-height: auto;
        display:block;
        margin: 0 auto;
        box-shadow: 2px 2px 5px #888888;
    }
}
</style>